import React, { useEffect, useState } from 'react';
import { SERVICE_WAKING_EVENT } from '../api/http';
import './ServiceWakingBanner.css';

// Shows a transient notice while http.ts retries through a backend cold start.
export default function ServiceWakingBanner() {
  const [waking, setWaking] = useState(false);

  useEffect(() => {
    const onWaking = (e: Event) => {
      const detail = (e as CustomEvent<{ waking: boolean }>).detail;
      setWaking(Boolean(detail?.waking));
    };
    window.addEventListener(SERVICE_WAKING_EVENT, onWaking);
    return () => window.removeEventListener(SERVICE_WAKING_EVENT, onWaking);
  }, []);

  if (!waking) return null;

  return (
    <div className="waking-banner" role="status" aria-live="polite">
      <span className="spinner spinner--sm" />
      <span>Waking up the service… this can take a few seconds.</span>
    </div>
  );
}
